/*
 * File: environment.ts
 * Project: rast-app
 * Create Date: Monday, 28th July 2025
 * Author: Pedro Santos (pedro.santos@vonbraunlabs.com)
 * -----
 * Last Modified: Tuesday, 8th September 2026 2:12:10 pm
 * Modified by: Pedro Santos (pedro.santos@vonbraunlabs.com)
 * -----
 * Copyright (c) 2026 CPA Wernher von Braun
 * ----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	---------------------------------------------------------
 */

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//https://api.rast.devel.vonbraunlabs.com.br
export const environment = {
  production: false,
  apiUrl: 'https://api.rast.devel.vonbraunlabs.com.br',
  nominatimUrl: 'https://nominatim.openstreetmap.org',
  version: '1.1.1.10 Dev',
  organizationLoginUrl: 'https://platform.rast.devel.vonbraunlabs.com.br/login',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
